import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import Axios from "axios";
import { useFormik } from "formik";

import { confirmAlert } from "react-confirm-alert";
import { Link } from "react-router-dom";
import AkkhorLayout from "../../../layout/AkkhorLayout";
import { URL_LIST_ALL } from "../../../configs/api";

export default function ImportBangHang(props) {
    const { user } = useSelector((state) => state.auth);
    const [selectedFile, setSelectedFile] = useState(null);
    const [loading, setLoading] = useState(false);
    const [listDuan, setListDuan] = useState([]);

    const formik = useFormik({
        initialValues: {},
        enableReinitialize: true,

        onSubmit: (values, { setSubmitting, resetForm }) => {
            setLoading(true)
            let formData = new FormData();
            if (selectedFile) {
                formData.append('file', selectedFile, selectedFile.name)
                formData.append('type', 'banghang');
                formData.append('name', 'banghang');
                formData.append('duan_id', values.duan_id);
                Axios.post(URL_LIST_ALL + 'upload', formData, {
                    headers: {
                        ...user.config?.headers, // thêm Authorization nếu có
                        "Content-Type": "multipart/form-data", // quan trọng
                    },
                }).then(async (res) => {
                    console.log(res)
                    setLoading(false)
                    setSubmitting(false);
                    if (res.data.status === "success") {
                        resetForm();
                        confirmAlert({
                            title: 'Thành công',
                            message: 'Bạn đã tải lên bảng hàng thành công',
                            buttons: [{ label: 'OK' }]
                        });
                    } else {
                        confirmAlert({
                            title: 'Lỗi',
                            message: res.data.message,
                            buttons: [{ label: 'OK' }]
                        });
                    }
                }).catch((err) => { setLoading(true); console.log(err) });
            } else {
                alert("Vui lòng chọn file")
            }
        },
    });
    useEffect(
        function () {
            let mounted = true;
            Axios.get(URL_LIST_ALL + "duan?status=1", user.config)
                .then(async (res) => {
                    if (res.data.status === "success") {
                        if (mounted) {
                            setListDuan(res.data.data);
                        }
                    } else console.log(res.data.message);
                })
                .catch((err) => console.log(err));
            return () => (mounted = false);

        }, [user]
    );

    return (
        <AkkhorLayout idrole="bang-hang" >
            <div className="breadcrumbs-area">
                <ul>
                    <li>
                        <Link to="/">Trang chủ</Link>
                    </li>

                    <li>Import bảng hàng</li>
                </ul>
            </div>
            <div className="card height-auto mt-4">
                <div className="card-body">
                    <div className="heading-layout1">
                        <div className="item-title">
                            <h3>Import bảng hàng</h3>
                        </div>
                    </div>
                    <form className="new-added-form" method="post" onSubmit={formik.handleSubmit}>
                        <div className="row">
                            <div className="col-12 form-group">
                                <label>Mẫu file bảng hàng</label>
                                <a className="btn btn-sm btn-info text-white" target="_blank" href="https://docs.google.com/spreadsheets/d/1H9MC4Rydf3HEozZ-MAN-D1JYnIrbR0UXNFY052enZDo/edit?usp=sharing"><i className="fas fa-download"></i> Xem mẫu</a>
                            </div>
                            <div className="col-12 mg-t-8">

                                <div className="my-3">
                                    <input type="file" onChange={(e) => setSelectedFile(e.target.files[0])}></input>
                                </div>
                                <div className="my-3">
                                    <select className="form-select form-control form-control-sm height32" {...formik.getFieldProps("duan_id")}>
                                        <option value="0" >Chọn dự án</option>
                                        {listDuan.map((item) => <option value={item.id} key={item.id} >{item.title}</option>)}
                                    </select>
                                </div>
                                <div className="alert alert-primary" role="alert">

                                    <div className="mt-3">
                                        <button type="submit" disabled={formik.isSubmitting} className="btn btn-success">{loading ? <div className="loader"></div> : <>Bắt đầu import</>}</button>
                                        <button type="reset" onClick={formik.resetForm} className="btn btn-warning ml-2">Nhập lại</button>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </form>
                </div>
            </div>
        </AkkhorLayout>
    );
}
